import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import * as moment from "moment";
import { BaseUrlConstantsService } from "../../../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../../../app/services/powertrain.service";
import { ConvertDatetimePipe } from "../../../../../app/convert-datetime.pipe";
import { PiezeoDashboardService } from "../../../../../app/services/piezo-dashboard.service";
import * as CanvasJS from "../../../../../components/client/powertrain-healthbar/canvasjs.stock.min";
import { BackendApiService } from "../../../../../app/services/backend-api.service";
import { Subscription } from "rxjs";

interface HealthData {
  name: string;
  value: number;
  status: string;
  timestamp: string;
  color: string;
}

@Component({
  selector: "app-piezo-healthbar",
  templateUrl: "./piezo-healthbar.component.html",
  styleUrl: "./piezo-healthbar.component.scss",
  standalone: true,
  imports: [CommonModule, NgxChartsModule],
})
export class PiezoHealthbar implements OnInit, OnDestroy {
  powertrainHealthBarUrl = BaseUrlConstantsService.POWERTRAIN_HEALTH_BAR_API;
  public BHEL_ON_PREM: boolean = BaseUrlConstantsService.BHEL_ON_PREM;

  @Input("asset_ids") asset_ids: string[] = [];
  @Input("mac_addresses") mac_addresses: string[] = [];
  @Input("client_id") client_id: string[] = [];

  emsaver_asset_ids: string[] = [];
  piezo_asset_ids: string[] = [];

  chartData: HealthData[] = [];
  selectedBar: any = null;
  sub!: Subscription;
  is_fetching = false;
  private stackChart = null;


  public stackvelocitychartLoader = false;
  public stackvelocitychartErr = "";
  public type1Devices = [];
  public type2Devices = [];
  public type3Devices = [];
  public type4Devices = [];

  colorScheme = {
    domain: ["#4CAF50", "#FF9800", "#F44336", "#9E9E9E"],
  };

  customColors: any[] = [];
  service = inject(PiezeoDashboardService);
  stackData: any[];
  intervalId: any;

  constructor(private backendService: BackendApiService) { }

  ngOnInit() {
    try {
      let subsystem_data = null;
      this.sub = this.service.subsystem_data$.subscribe((data) => {
        console.log('NEW DATA RECEIVED IN HEALTHBAR SUBSCRIPTION')
        subsystem_data = data;
        this.client_id = subsystem_data.client_id;
        let parsedData =
          typeof subsystem_data.device_position == "string"
            ? JSON.parse(subsystem_data.device_position)
            : subsystem_data.device_position;
        //RESET ALL ARRAYS
        this.type1Devices = [];
        this.type2Devices = [];
        this.type3Devices = [];
        this.type4Devices = [];
        parsedData.forEach((dp) => {
          const masterType = Number(dp.master_type); // Convert string to number
          const device = {
            asset_id: dp.asset_id,
            mac_address: dp.mac_address,
            master_type: masterType,
          };
          console.log(device)
          console.log(masterType)
          console.log(dp)
          switch (masterType) {
            case 1:
              this.type1Devices.push(device);
              break;
            case 2:
              this.type2Devices.push(device);
              break;
            case 3:
              this.type3Devices.push(device);
              break;
            case 4:
              this.type4Devices.push(device);
              break;
            default:
              console.log("Unknown master_type:", masterType);
          }
          console.log(this.type4Devices)
          // Log results
          console.log('reached here calling healthbar fetch api')
        });
        this.parseAssetIds(subsystem_data.device_position);
        this.fetchMachineHealthbar();
      });
    } catch (error) {
      console.log(error)
    }


    // this.intervalId = setInterval(() => {
    //   this.fetchMachineHealthbar();
    // }, 30000);
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  parseAssetIds(sensors?: any) {
    sensors = typeof sensors == "string" ? JSON.parse(sensors) : sensors;
    if (!sensors) return;
    this.asset_ids = [];
    sensors.forEach((sensor: any) => {
      if (sensor.master_type != 4) {
        this.emsaver_asset_ids.push(sensor.asset_id);
      } else {
        this.piezo_asset_ids.push(sensor.asset_id);
      }
      this.asset_ids.push(sensor.asset_id);
    });
  }
  async fetchMachineHealthbar() {
    const container = document.getElementById("stackvelocitychartContainer");
    if (!container) return;
    container.innerHTML = "";

    try {
      if (this.is_fetching) {
        return;
      }
      this.is_fetching = true;
      this.stackData = [];
      const deviceParams = {
        type1: this.type1Devices,
        type2: this.type2Devices,
        type3: this.type3Devices,
        type4: this.type4Devices,
      };
      this.stackvelocitychartLoader = true;
      this.stackvelocitychartErr = "";
      let url = `${this.powertrainHealthBarUrl}/${this.client_id}/30/12`;
      await this.backendService
        .postData(url, deviceParams)
        .then((res: any) => {
          if (JSON.parse(JSON.stringify(res)).status == "success") {
            let resdata = JSON.parse(JSON.stringify(res)).machineHealthData;
            if (resdata.length > 0) {
              for (let i = 1; i < resdata.length-1; i++) {
                // let testDateUtc = moment.utc(resdata[i].bucket_date).toDate();
                let timeUpdatedAt = resdata[i].timestamp;

                // new ConvertDatetimePipe().convertDateTime(
                //   testDateUtc
                // );
                // console.log(resdata[i].bucket_date +  "=>" + testDateUtc + "=>" + timeUpdatedAt);
                let dateandtime = timeUpdatedAt.split(" ");
                let date = dateandtime[0].toString();
                let time = dateandtime[1].toString();

                let velocityStatus = resdata[i].vibration_err_status || "N/A";
                let temperatureStatus = resdata[i].temp_err_status || "N/A";
                let ultrasoundStatus =
                  resdata[i].ultrasound_err_status || "N/A";
                switch (resdata[i].status) {
                  case "HEALTHY":
                    this.stackData.push(this.BHEL_ON_PREM == false ? {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#72FF13",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          // ultrasoundStatus: ultrasoundStatus
                        },
                      ],
                    } : {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#72FF13",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                        },
                      ],
                    });
                    break;
                  case "UNSATISFACTORY":
                    this.stackData.push(this.BHEL_ON_PREM == false ? {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#FAA700",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          // ultrasoundStatus: ultrasoundStatus
                        },
                      ],
                    } : {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#FAA700",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                        },
                      ],
                    });
                    break;
                  case "UNACCEPTABLE":
                    this.stackData.push(this.BHEL_ON_PREM == false ? {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#ff2a1b",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          // ultrasoundStatus: ultrasoundStatus
                        },
                      ],
                    } : {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#ff2a1b",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                        },
                      ],
                    });
                    break;
                  case "IDLE":
                    this.stackData.push(this.BHEL_ON_PREM == false ? {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#cecece",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          // ultrasoundStatus: ultrasoundStatus
                        },
                      ],
                    } : {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#cecece",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                        },
                      ],
                    });
                    break;
                  case "OFFLINE":
                    this.stackData.push(this.BHEL_ON_PREM == false ? {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#cecece",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          // ultrasoundStatus: ultrasoundStatus
                        },
                      ],
                    } : {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#cecece",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          status: resdata[i].status,
                          velocityStatus: velocityStatus,
                        },
                      ],
                    });
                    break;
                  default:
                    this.stackData.push(this.BHEL_ON_PREM == false ? {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#999999",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          // ultrasoundStatus: ultrasoundStatus
                        },
                      ],
                    } : {
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#999999",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          velocityStatus: velocityStatus,
                        },
                      ],
                    });
                    break;
                }
              }
              // console.log("Stack data")
              // console.log(this.stackData)
              // console.log(this.stackData.length)
              if (this.stackChart) {
                this.stackChart.destroy();
                this.stackChart = null;
              }
              this.stackChart = new CanvasJS.Chart(
                "stackvelocitychartContainer",
                {
                  axisX: {
                    valueFormatString: " ",
                    titleFontSize: 100,
                    gridThickness: 0,
                    lineThickness: 0,
                    tickThickness: 0,
                  },
                  axisY: {
                    titleFontSize: 135,
                    valueFormatString: " ",
                    gridThickness: 0,
                    lineThickness: 0,
                    tickThickness: 0,
                  },
                  toolTip: {
                    contentFormatter: function (e) {
                      const dataPoint = e.entries[0].dataPoint;

                      // Helper function to get status color
                      function getStatusColor(status) {
                        switch (status) {
                          case "HEALTHY":
                            return "#72FF13"; // Green
                          case "UNSATISFACTORY":
                            return "#FAA700"; // Orange/Amber
                          case "UNACCEPTABLE":
                            return "#ff2a1b"; // Red
                          case "IDLE":
                            return "#cecece"; // idle
                          default:
                            return "#999999"; // Gray for unknown/undefined
                        }
                      }

                      // Color formatting for each status
                      const velocityColor = getStatusColor(
                        dataPoint.velocityStatus,
                      );
                      const temperatureColor = getStatusColor(
                        dataPoint.temperatureStatus,
                      );
                      // const ultrasoundColor = getStatusColor(dataPoint.ultrasoundStatus);
                      // <b>Ultrasound:</b> <span style="color:${ultrasoundColor}; font-weight:bold">${dataPoint.ultrasoundStatus}</span>
                      let final_string = `<div style="padding: 5px;">
                                <b>Time:</b> ${dataPoint.time}<br/>
                                <b>Status:</b> ${dataPoint.status}<br/>
                                <b>Velocity:</b> <span style="color:${velocityColor}; font-weight:bold">${dataPoint.velocityStatus}</span><br/>
                                <b>Temperature:</b> <span style="color:${temperatureColor}; font-weight:bold">${dataPoint.temperatureStatus}</span>
                        </div>
                              `
                      if (this.BHEL_ON_PREM == false) {
                        final_string += `<b>Temperature:</b> <span style="color:${temperatureColor}; font-weight:bold">${dataPoint.temperatureStatus}</span>
                        </div>`
                      } else {
                        final_string += `</div>`
                      }
                      return final_string;
                    },
                    shared: false,
                  },
                  dataPointWidth: 65,

                  data: this.stackData,
                  afterRender: function () {
                    this.stackvelocitychartLoader = false;
                  },
                },
              );
              // setTimeout(() => {
              //   console.log("rendering chart...");
              //   if (chart11) chart11.render();
              // }, 200);
              this.stackChart.render();
              // chart11.render();
              this.stackvelocitychartLoader = false;
            } else {
              this.stackvelocitychartErr = "No Data Available";
            }
            // delete resdata[0];
          } else {
            this.stackvelocitychartErr = "No Data Available";
          }
        })
        .catch((err) => {
          this.stackvelocitychartErr = "No Data Available";
          this.chartData = [];
          this.is_fetching = false;
          this.stackvelocitychartLoader = false;
        })
        .finally(() => {
          this.stackvelocitychartLoader = false;
          this.is_fetching = false;
        });
    } catch (error) {
      console.log(error);
      this.is_fetching = false;
      this.stackvelocitychartLoader = false;

    }
  }

  getStatusFromColor(hex: string): string {
    if (!hex) return "Unknown";

    const color = hex.toLowerCase();

    if (color === "#72ff13") return "Healthy"; // Green
    if (color === "#ffff00") return "Warning"; // Yellow
    if (color === "#ff0000") return "Critical"; // Red

    return "Unknown";
  }

  onSelect(event: any) {
    const selected = this.chartData.find((d) => d.name === event.name);
    if (selected) {
      this.selectedBar = {
        status: selected.status,
        timestamp: selected.timestamp,
        value: "N/A",
        count: 0,
        metrics: "N/A",
      };
    }
  }
}
